// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "wc-checkbox[data-v-054c6b91] {\n  margin-left: 0;\n}\n.error-message[data-v-054c6b91] {\n  display: flex;\n}\n.error-message .icon[data-v-054c6b91] {\n  margin-right: 4px;\n}", ""]);
// Exports
module.exports = exports;
